var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _path, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _path2, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _path3, _path4, _path5, _path6, _symbol50, _path7, _path8, _path9, _path10, _circle, _path11, _path12, _path13, _path14, _path15, _path16, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _symbol92, _symbol93, _symbol94, _symbol95, _symbol96, _symbol97;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "accepted",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    fill: "#24A148",
    stroke: "#24A148",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5L11 16L16 9",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "add_broker",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4383 13.5728L11.0092 12.7518L10.534 12.4214L10.0108 12.6688L10.4383 13.5728ZM19.5617 13.5728L19.9892 12.6688L19.466 12.4214L18.9909 12.7518L19.5617 13.5728ZM8 19C8 17.0038 9.16982 15.2788 10.8657 14.4768L10.0108 12.6688C7.64206 13.7888 6 16.2017 6 19H8ZM9 20C8.44772 20 8 19.5523 8 19H6C6 20.6569 7.34315 22 9 22V20ZM15 20H9V22H15V20ZM21 20H15V22H21V20ZM22 19C22 19.5523 21.5523 20 21 20V22C22.6569 22 24 20.6569 24 19H22ZM19.1343 14.4768C20.8302 15.2788 22 17.0038 22 19H24C24 16.2017 22.3579 13.7888 19.9892 12.6688L19.1343 14.4768ZM18.9909 12.7518C17.859 13.5388 16.4849 14 15 14V16C16.9061 16 18.6765 15.4063 20.1326 14.3938L18.9909 12.7518ZM15 14C13.5151 14 12.141 13.5388 11.0092 12.7518L9.86737 14.3938C11.3235 15.4063 13.0939 16 15 16V14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 7,
    r: 4,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7V13",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10L1 10",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17L13 15H17L15.5 17L17 20H13L14.5 17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "black"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "add_idd",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 14V18C11 19.1046 11.8954 20 13 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4H13C11.8954 4 11 4.89543 11 6V8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6V16",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11L1 11",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8L16 8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 11L17 11",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 16L15 16",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "add_new_calculation",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 14V19C9 20.1046 9.89543 21 11 21H21C22.1046 21 23 20.1046 23 19V5C23 3.89543 22.1046 3 21 3H11C9.89543 3 9 3.89543 9 5V6",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6V14",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10L1 10",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 11L17 11",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8H15",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 17L13 17",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "add_user",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4383 13.5728L11.0092 12.7517L10.534 12.4213L10.0108 12.6687L10.4383 13.5728ZM19.5617 13.5728L19.9892 12.6687L19.466 12.4213L18.9909 12.7517L19.5617 13.5728ZM8 18.9999C8 17.0037 9.16982 15.2787 10.8657 14.4768L10.0108 12.6687C7.64206 13.7888 6 16.2016 6 18.9999H8ZM9 19.9999C8.44772 19.9999 8 19.5522 8 18.9999H6C6 20.6568 7.34315 21.9999 9 21.9999V19.9999ZM15 19.9999H9V21.9999H15V19.9999ZM21 19.9999H15V21.9999H21V19.9999ZM22 18.9999C22 19.5522 21.5523 19.9999 21 19.9999V21.9999C22.6569 21.9999 24 20.6568 24 18.9999H22ZM19.1343 14.4768C20.8302 15.2787 22 17.0037 22 18.9999H24C24 16.2016 22.3579 13.7888 19.9892 12.6687L19.1343 14.4768ZM18.9909 12.7517C17.859 13.5387 16.4849 13.9999 15 13.9999V15.9999C16.9061 15.9999 18.6765 15.4063 20.1326 14.3938L18.9909 12.7517ZM15 13.9999C13.5151 13.9999 12.141 13.5387 11.0092 12.7517L9.86737 14.3938C11.3235 15.4063 13.0939 15.9999 15 15.9999V13.9999Z",
    fill: "black",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 7,
    r: 4,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7V13",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10L1 10",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "agent",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.43826 13.5728L8.00915 12.7517L7.53399 12.4213L7.01079 12.6687L7.43826 13.5728ZM16.5617 13.5728L16.9892 12.6687L16.466 12.4213L15.9909 12.7517L16.5617 13.5728ZM5 18.9999C5 17.0037 6.16982 15.2787 7.86573 14.4768L7.01079 12.6687C4.64206 13.7888 3 16.2016 3 18.9999H5ZM6 19.9999C5.44772 19.9999 5 19.5522 5 18.9999H3C3 20.6568 4.34315 21.9999 6 21.9999V19.9999ZM12 19.9999H6V21.9999H12V19.9999ZM18 19.9999H12V21.9999H18V19.9999ZM19 18.9999C19 19.5522 18.5523 19.9999 18 19.9999V21.9999C19.6569 21.9999 21 20.6568 21 18.9999H19ZM16.1343 14.4768C17.8302 15.2787 19 17.0037 19 18.9999H21C21 16.2016 19.3579 13.7888 16.9892 12.6687L16.1343 14.4768ZM15.9909 12.7517C14.859 13.5387 13.4849 13.9999 12 13.9999V15.9999C13.9061 15.9999 15.6765 15.4063 17.1326 14.3938L15.9909 12.7517ZM12 13.9999C10.5151 13.9999 9.14096 13.5387 8.00915 12.7517L6.86737 14.3938C8.3235 15.4063 10.0939 15.9999 12 15.9999V13.9999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 4,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17L10 15H14L12.5 17L14 20H10L11.5 17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "black"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "arrow_down",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 9L12 16L19 9",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "arrow_left",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2793 12.2071L5.2793 12.2071",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2793 17.2071L5.2793 12.2071L10.2793 7.20714",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    fill: "none",
    id: "arrow_nav_right",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 4L10 8L6 12",
    stroke: "black",
    strokeWidth: 2
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    fill: "none",
    id: "assistance",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11,
    width: 34,
    height: 5,
    rx: 2,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 25H34C35.1046 25 36 24.1046 36 23V22C36 20.8954 35.1046 20 34 20H4C2.89543 20 2 20.8954 2 22V23C2 24.1046 2.89543 25 4 25H25",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 28H30",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 23L23.2043 34.1828C23.0842 34.6631 22.6527 35 22.1577 35H21.5C20.6716 35 20 35.6716 20 36.5C20 37.3284 20.6716 38 21.5 38H33.5C34.3284 38 35 37.3284 35 36.5C35 35.6716 34.3284 35 33.5 35H32.8423C32.3473 35 31.9158 34.6631 31.7957 34.1828L29 23H26Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 31H31",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 35H33",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20V16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11V8H8V11",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16V20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 25V31H8V25",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 20V16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 11V8H34V11",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 16V20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 5,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 5,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 25V31H31",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "attachment",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 8V17C6 20.3137 8.68629 23 12 23V23C15.3137 23 18 20.3137 18 17V5C18 2.79086 16.2091 1 14 1V1C11.7909 1 10 2.79086 10 5V17C10 18.1046 10.8954 19 12 19V19C13.1046 19 14 18.1046 14 17V8",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "banknotes",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 8,
    width: 19,
    height: 12,
    rx: 2,
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 19,
    height: 12,
    rx: 2,
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5,
    cy: 11,
    rx: 2.5,
    ry: 3,
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 11,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 11,
    r: 1,
    fill: "currentColor"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "border",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM4 12C4 11.101 4.156 10.238 4.431 9.431L6 11L8 13V15L10 17L11 18V19.931C7.061 19.436 4 16.072 4 12ZM18.33 16.873C17.677 16.347 16.687 16 16 16V15C16 14.4696 15.7893 13.9609 15.4142 13.5858C15.0391 13.2107 14.5304 13 14 13H10V10C10.5304 10 11.0391 9.78929 11.4142 9.41421C11.7893 9.03914 12 8.53043 12 8V7H13C13.5304 7 14.0391 6.78929 14.4142 6.41421C14.7893 6.03914 15 5.53043 15 5V4.589C17.928 5.778 20 8.65 20 12C19.9998 13.7647 19.4123 15.4791 18.33 16.873Z",
    fill: "black"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "bot",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 8V4H8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    x: 4,
    y: 8,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 14h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13v2"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "calculation",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 18,
    rx: 2,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11L15 11",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17L15 17",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8L15 8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "calculations",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1,
    width: 14,
    height: 18,
    rx: 2,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 4H18C19.1046 4 20 4.89543 20 6V20C20 21.1046 19.1046 22 18 22H8C6.89543 22 6 21.1046 6 20V19",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9L13 9",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 15L13 15",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6L13 6",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    fill: "none",
    id: "calculations2",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 28,
    height: 36,
    rx: 2,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 10H38C39.1046 10 40 10.8954 40 12V42C40 43.1046 39.1046 44 38 44H16C14.8954 44 14 43.1046 14 42V40",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 14L30 14",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 22L30 22",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 34L30 34",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 28L30 28",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18L30 18",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 10L30 10",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 24V20",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 22L18 22",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 426.667 426.667",
    style: {
      enableBackground: "new 0 0 426.667 426.667"
    },
    xmlSpace: "preserve",
    id: "check",
    xmlns: "http://www.w3.org/2000/svg"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421.876,56.307c-6.548-6.78-17.352-6.968-24.132-0.42c-0.142,0.137-0.282,0.277-0.42,0.42L119.257,334.375    l-90.334-90.334c-6.78-6.548-17.584-6.36-24.132,0.42c-6.388,6.614-6.388,17.099,0,23.713l102.4,102.4    c6.665,6.663,17.468,6.663,24.132,0L421.456,80.44C428.236,73.891,428.424,63.087,421.876,56.307z"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 6 7",
    fill: "none",
    id: "check_bold",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 3.5L2.5 5.5L5 1.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "check_orange",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 12L11.5 16L17 7.5",
    stroke: "#FF7D00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "check_small",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 12L11.5 16L17 7.5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 1024 1024",
    id: "chevron_left",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 512 512)",
    d: "M104.704 338.752a64 64 0 0 1 90.496 0l316.8 316.8 316.8-316.8a64 64 0 0 1 90.496 90.496L557.248 791.296a64 64 0 0 1-90.496 0L104.704 429.248a64 64 0 0 1 0-90.496z"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "close",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 17L17 7.00001",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17L7 7",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "coin",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 12) scale(1.43) translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 13.5127C15 12.2255 14.1717 11.6755 12.9038 11.3784L11.9324 11.1364C11.4109 11.0154 11.1348 10.8394 11.1348 10.4323C11.1348 9.94829 11.5336 9.68427 12.1266 9.68427C12.7761 9.68427 13.105 10.0105 13.225 10.5H14.9764C14.7977 9.0223 13.7758 8.42427 12.8118 8.22112V7H11.4722V8.17712C10.1327 8.36414 9.25329 9.26623 9.25329 10.5864C9.25329 11.7745 9.8975 12.4675 11.2677 12.7866L12.413 13.0616C13.006 13.1826 13.1492 13.4466 13.1492 13.6997C13.1492 14.1067 12.8118 14.3597 12.1675 14.3597C11.4342 14.3597 10.931 14.0415 10.7536 13.5H9C9.20988 14.965 10.2378 15.7102 11.4722 15.8999V17H12.8118V15.8889C14.1513 15.6689 15 14.7998 15 13.5127Z",
    stroke: "none"
  })))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "coin_orange",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7,
    stroke: "#FF7D00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13.5127C15 12.2255 14.1717 11.6755 12.9038 11.3784L11.9324 11.1364C11.4109 11.0154 11.1348 10.8394 11.1348 10.4323C11.1348 9.94829 11.5336 9.68427 12.1266 9.68427C12.7761 9.68427 13.105 10.0105 13.225 10.5H14.9764C14.7977 9.0223 13.7758 8.42427 12.8118 8.22112V7H11.4722V8.17712C10.1327 8.36414 9.25329 9.26623 9.25329 10.5864C9.25329 11.7745 9.8975 12.4675 11.2677 12.7866L12.413 13.0616C13.006 13.1826 13.1492 13.4466 13.1492 13.6997C13.1492 14.1067 12.8118 14.3597 12.1675 14.3597C11.4342 14.3597 10.931 14.0415 10.7536 13.5H9C9.20988 14.965 10.2378 15.7102 11.4722 15.8999V17H12.8118V15.8889C14.1513 15.6689 15 14.7998 15 13.5127Z",
    fill: "#FF7D00"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "company",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 18H8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 18V21",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18H18",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 15H8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15H18",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12H8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9H9",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 21H4C2.89543 21 2 20.1046 2 19V7.52759C2 6.62569 2.60364 5.83537 3.47377 5.59806L10.4738 3.68897C11.746 3.34199 13 4.29975 13 5.6185V11",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13C12 11.8954 12.8954 11 14 11H20C21.1046 11 22 11.8954 22 13V19C22 20.1046 21.1046 21 20 21H12V13Z",
    stroke: "black",
    strokeWidth: 2
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "copy",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 18H19C20.1046 18 21 17.1046 21 16V4C21 2.89543 20.1046 2 19 2H11C9.89543 2 9 2.89543 9 4V6",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 20C15 21.1046 14.1046 22 13 22L8.82843 22C8.29799 22 7.78929 21.7893 7.41421 21.4142L3.58579 17.5858C3.21071 17.2107 3 16.702 3 16.1716L3 8C3 6.89543 3.89543 6 5 6L13 6C14.1046 6 15 6.89543 15 8L15 20Z",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22L9 18C9 16.8954 8.10457 16 7 16L3 16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "declined",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    fill: "#DA1E28",
    stroke: "#DA1E28",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15L15 9",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15L9 9",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "download",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 16V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V16",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10L12 15L17 10",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15V1",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "edit",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 14.4142V17H7.58579C7.851 17 8.10536 16.8946 8.29289 16.7071L17.5 7.5C18.3284 6.67157 18.3284 5.32843 17.5 4.5C16.6716 3.67157 15.3284 3.67157 14.5 4.5L5.29289 13.7071C5.10536 13.8946 5 14.149 5 14.4142Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 6L16 9",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21H19",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "edit_filled",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 14.4142V17H7.58579C7.851 17 8.10536 16.8946 8.29289 16.7071L17.5 7.5C18.3284 6.67157 18.3284 5.32843 17.5 4.5C16.6716 3.67157 15.3284 3.67157 14.5 4.5L5.29289 13.7071C5.10536 13.8946 5 14.149 5 14.4142Z",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 6L16 9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21H19",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "email",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 6,
    height: 6,
    rx: 3,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 20H16H12V20C7.58172 20 4 16.4183 4 12V12C4 7.58172 7.58172 4 12 4V4C16.4183 4 20 7.58172 20 12V12V12.5C20 13.8807 18.8807 15 17.5 15V15C16.1193 15 15 13.8807 15 12.5V12",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "exclamation_mark",
    viewBox: "0 0 286.054 286.054",
    style: {
      enableBackground: "new 0 0 286.054 286.054"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2574C"
    },
    d: "M143.027,0C64.04,0,0,64.04,0,143.027c0,78.996,64.04,143.027,143.027,143.027   c78.996,0,143.027-64.022,143.027-143.027C286.054,64.04,222.022,0,143.027,0z M143.027,259.236   c-64.183,0-116.209-52.026-116.209-116.209S78.844,26.818,143.027,26.818s116.209,52.026,116.209,116.209   S207.21,259.236,143.027,259.236z M143.036,62.726c-10.244,0-17.995,5.346-17.995,13.981v79.201c0,8.644,7.75,13.972,17.995,13.972   c9.994,0,17.995-5.551,17.995-13.972V76.707C161.03,68.277,153.03,62.726,143.036,62.726z M143.036,187.723   c-9.842,0-17.852,8.01-17.852,17.86c0,9.833,8.01,17.843,17.852,17.843s17.843-8.01,17.843-17.843   C160.878,195.732,152.878,187.723,143.036,187.723z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "exclamation_mark_fillable",
    viewBox: "0 0 286.054 286.054",
    style: {
      enableBackground: "new 0 0 286.054 286.054"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.027,0C64.04,0,0,64.04,0,143.027c0,78.996,64.04,143.027,143.027,143.027   c78.996,0,143.027-64.022,143.027-143.027C286.054,64.04,222.022,0,143.027,0z M143.027,259.236   c-64.183,0-116.209-52.026-116.209-116.209S78.844,26.818,143.027,26.818s116.209,52.026,116.209,116.209   S207.21,259.236,143.027,259.236z M143.036,62.726c-10.244,0-17.995,5.346-17.995,13.981v79.201c0,8.644,7.75,13.972,17.995,13.972   c9.994,0,17.995-5.551,17.995-13.972V76.707C161.03,68.277,153.03,62.726,143.036,62.726z M143.036,187.723   c-9.842,0-17.852,8.01-17.852,17.86c0,9.833,8.01,17.843,17.852,17.843s17.843-8.01,17.843-17.843   C160.878,195.732,152.878,187.723,143.036,187.723z"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "external",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7L7 7C5.34315 7 4 8.34315 4 10L4 17C4 18.6569 5.34315 20 7 20L14 20C15.6569 20 17 18.6569 17 17V12",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10L20 4L14 4",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4L12 12",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    stroke: "none",
    id: "eye",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.83209 12L1.91574 11.5996L1.74081 12L1.91574 12.4004L2.83209 12ZM21.1679 12L22.0843 12.4004L22.2592 12L22.0843 11.5996L21.1679 12ZM3.74845 12.4004C5.13816 9.21965 8.31098 7 12 7V5C7.48775 5 3.61225 7.71673 1.91574 11.5996L3.74845 12.4004ZM12 7C15.689 7 18.8618 9.21966 20.2516 12.4004L22.0843 11.5996C20.3878 7.71674 16.5123 5 12 5V7ZM20.2516 11.5996C18.8618 14.7804 15.689 17 12 17V19C16.5123 19 20.3878 16.2833 22.0843 12.4004L20.2516 11.5996ZM12 17C8.31098 17 5.13816 14.7803 3.74845 11.5996L1.91574 12.4004C3.61225 16.2833 7.48775 19 12 19V17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8284 9.17157C14.1741 8.5172 13.313 8.10997 12.3921 8.01926C11.4711 7.92855 10.5472 8.15999 9.77772 8.67412C9.00826 9.18826 8.44087 9.95329 8.17224 10.8389C7.9036 11.7244 7.95034 12.6758 8.30448 13.5307C8.65863 14.3857 9.29826 15.0914 10.1144 15.5277C10.9306 15.9639 11.8727 16.1037 12.7804 15.9231C13.688 15.7426 14.505 15.2529 15.092 14.5376C15.6791 13.8222 16 12.9254 16 12H12L14.8284 9.17157Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "eye_closed",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.59497 12.594C4.9623 14.6926 8.30069 16 12 16C15.6992 16 19.0376 14.6926 21.405 12.594",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13L1 14.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 13L23 14.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15L4 17",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15L20 17",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16L8 19",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 16L16 19",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16V19.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "file_text",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4C4 2.89543 4.89543 2 6 2H14.1716C14.702 2 15.2107 2.21071 15.5858 2.58579L19.4142 6.41421C19.7893 6.78929 20 7.29799 20 7.82843V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4Z",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2V6C14 7.10457 14.8954 8 16 8H20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13H16",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 17H16",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "folder",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 21H5C3.34315 21 2 19.6569 2 18V5C2 3.89543 2.89543 3 4 3H8.92963C9.59834 3 10.2228 3.3342 10.5937 3.8906L11.4063 5.1094C11.7772 5.6658 12.4017 6 13.0704 6H17C18.6569 6 20 7.34315 20 9V10",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52127 11.3165C5.80868 10.5261 6.55984 10 7.40085 10H20.1446C21.5325 10 22.4985 11.3791 22.0242 12.6835L19.7181 19.0252C19.287 20.2108 18.1602 21 16.8987 21H4.8554C3.46747 21 2.5015 19.6209 2.97581 18.3165L5.52127 11.3165Z",
    stroke: "black",
    strokeWidth: 2
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 14 14",
    fill: "none",
    id: "glass",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 4V10C13 11.1046 12.1046 12 11 12H3C1.89543 12 1 11.1046 1 10V8.7241C1 8.25623 1.16403 7.80316 1.46356 7.44373L5.40031 2.71963C5.78029 2.26365 6.34319 2 6.93675 2H11C12.1046 2 13 2.89543 13 4Z",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 12V11.7016C4 11.2474 4.15456 10.8068 4.43826 10.4522L7.39951 6.75061C7.77906 6.27618 8.35368 6 8.96125 6H13",
    strokeWidth: 2
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "globe",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM4 12C4 11.101 4.156 10.238 4.431 9.431L6 11L8 13V15L10 17L11 18V19.931C7.061 19.436 4 16.072 4 12ZM18.33 16.873C17.677 16.347 16.687 16 16 16V15C16 14.4696 15.7893 13.9609 15.4142 13.5858C15.0391 13.2107 14.5304 13 14 13H10V10C10.5304 10 11.0391 9.78929 11.4142 9.41421C11.7893 9.03914 12 8.53043 12 8V7H13C13.5304 7 14.0391 6.78929 14.4142 6.41421C14.7893 6.03914 15 5.53043 15 5V4.589C17.928 5.778 20 8.65 20 12C19.9998 13.7647 19.4123 15.4791 18.33 16.873Z",
    fill: "black"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "house",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14,
    width: 6,
    height: 7,
    fill: "none",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12H5V20C5 20.5523 5.44772 21 6 21H18C18.5523 21 19 20.5523 19 20V12H21L12 3L3 12Z",
    fill: "none",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "household",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14,
    width: 6,
    height: 7,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12H5V20C5 20.5523 5.44772 21 6 21H18C18.5523 21 19 20.5523 19 20V12H21L12 3L3 12Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 233 233",
    fill: "none",
    id: "info",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233 116.5C233 180.841 180.841 233 116.5 233C52.1588 233 0 180.841 0 116.5C0 52.1588 52.1588 0 116.5 0C180.841 0 233 52.1588 233 116.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.391 91.1289V70.1589H129.643V91.1289H103.391ZM103.081 181.222V101.226H129.953V181.222H103.081Z",
    fill: "white"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "info_outline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11V17",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7.5,
    r: 1.25,
    fill: "black"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 25 24",
    fill: "none",
    stroke: "none",
    id: "key",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6688 12.5064L14.2345 11.6057C13.7813 11.8242 13.561 12.3453 13.7201 12.8226L14.6688 12.5064ZM10.5 12.584H11.5C11.5 12.1865 11.2646 11.8267 10.9004 11.6676L10.5 12.584ZM10.5 21H9.5C9.5 21.2652 9.60535 21.5196 9.79288 21.7071L10.5 21ZM12 22.5001L11.2929 23.2072C11.4804 23.3947 11.7348 23.5001 12 23.5001C12.2652 23.5001 12.5196 23.3947 12.7071 23.2072L12 22.5001ZM15 19.5L15.7071 20.2071C16.0976 19.8166 16.0976 19.1834 15.7071 18.7929L15 19.5ZM13.5 18L12.7929 17.2929C12.6054 17.4804 12.5 17.7348 12.5 18C12.5 18.2652 12.6054 18.5196 12.7929 18.7071L13.5 18ZM15 16.5001L15.7071 17.2072C15.8946 17.0196 16 16.7653 16 16.5001C16 16.2349 15.8946 15.9805 15.7071 15.793L15 16.5001ZM13.5 15.0001L12.7929 14.293C12.4024 14.6835 12.4024 15.3166 12.7929 15.7072L13.5 15.0001ZM15 13.5L15.7071 14.2071C15.9749 13.9393 16.0685 13.5431 15.9487 13.1838L15 13.5ZM16.5 8C16.5 9.58598 15.5771 10.9583 14.2345 11.6057L15.1031 13.4072C17.111 12.4391 18.5 10.3827 18.5 8H16.5ZM12.5 4C14.7091 4 16.5 5.79086 16.5 8H18.5C18.5 4.68629 15.8137 2 12.5 2V4ZM8.5 8C8.5 5.79086 10.2909 4 12.5 4V2C9.18629 2 6.5 4.68629 6.5 8H8.5ZM10.9004 11.6676C9.48556 11.0494 8.5 9.6387 8.5 8H6.5C6.5 10.4619 7.98263 12.5754 10.0996 13.5003L10.9004 11.6676ZM11.5 21V12.584H9.5V21H11.5ZM12.7071 21.793L11.2071 20.2929L9.79288 21.7071L11.2929 23.2072L12.7071 21.793ZM14.2929 18.7929L11.2929 21.793L12.7071 23.2072L15.7071 20.2071L14.2929 18.7929ZM12.7929 18.7071L14.2929 20.2071L15.7071 18.7929L14.2071 17.2929L12.7929 18.7071ZM14.2929 15.7929L12.7929 17.2929L14.2071 18.7071L15.7071 17.2072L14.2929 15.7929ZM12.7929 15.7072L14.2929 17.2072L15.7071 15.793L14.2071 14.293L12.7929 15.7072ZM14.2929 12.7929L12.7929 14.293L14.2071 15.7072L15.7071 14.2071L14.2929 12.7929ZM13.7201 12.8226L14.0513 13.8162L15.9487 13.1838L15.6175 12.1902L13.7201 12.8226Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.4998,
    cy: 7.2,
    r: 1.2,
    fill: "black"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "login",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 16.5L7 17C7 18.6569 8.34315 20 10 20L17 20C18.6569 20 20 18.6569 20 17L20 7C20 5.34315 18.6569 4 17 4L10 4C8.34315 4 7 5.34315 7 7L7 7.5",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16L16 12L12 8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12L2 12",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 14 14",
    fill: "none",
    id: "luggage",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5,
    width: 12,
    height: 8,
    rx: 2,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 5V2C4 1.44772 4.44772 1 5 1H9C9.55228 1 10 1.44772 10 2V5",
    strokeWidth: 2
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "mail",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 17V7C3 5.89543 3.89543 5 5 5H19C20.1046 5 21 5.89543 21 7V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6L9.87868 11.8787C11.0503 13.0503 12.9497 13.0503 14.1213 11.8787L20 6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "message",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V12",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9L2.58579 11.4142C2.21071 11.7893 2 12.298 2 12.8284V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V12.8284C22 12.298 21.7893 11.7893 21.4142 11.4142L19 9",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12L12 16L21 12",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 7L15 7",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10H12",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "more",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2,
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 12,
    r: 2,
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 12,
    r: 2,
    fill: "#D0D0D0"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "motor",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4142 7.58579C10.7893 7.21071 11.298 7 11.8284 7H16C16.6295 7 17.2223 7.29639 17.6 7.8L20 11H7L10.4142 7.58579Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16V17C5.55228 17 6 16.5523 6 16H5ZM9 16H8C8 16.5523 8.44772 17 9 17V16ZM16 16V17C16.5523 17 17 16.5523 17 16H16ZM20 16H19C19 16.5523 19.4477 17 20 17V16ZM3 13C3 12.4477 3.44772 12 4 12V10C2.34315 10 1 11.3431 1 13H3ZM3 14V13H1V14H3ZM4 15C3.44772 15 3 14.5523 3 14H1C1 15.6569 2.34315 17 4 17V15ZM5 15H4V17H5V15ZM7 13C5.34315 13 4 14.3431 4 16H6C6 15.4477 6.44772 15 7 15V13ZM10 16C10 14.3431 8.65685 13 7 13V15C7.55228 15 8 15.4477 8 16H10ZM16 15H9V17H16V15ZM18 13C16.3431 13 15 14.3431 15 16H17C17 15.4477 17.4477 15 18 15V13ZM21 16C21 14.3431 19.6569 13 18 13V15C18.5523 15 19 15.4477 19 16H21ZM21 14C21 14.5523 20.5523 15 20 15V17C21.6569 17 23 15.6569 23 14H21ZM21 13V14H23V13H21ZM20 12C20.5523 12 21 12.4477 21 13H23C23 11.3431 21.6569 10 20 10V12ZM4 12H20V10H4V12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 16,
    r: 2,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 16,
    r: 2,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    id: "nav_cars",
    xmlns: "http://www.w3.org/2000/svg"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M467,199.665h-17.372l-65.345-134.23c-2.512-5.16-7.747-8.435-13.486-8.435H141.203c-5.739,0-10.975,3.274-13.487,8.435   l-65.345,134.23H45c-24.813,0-45,20.187-45,45V363.19c0,8.284,6.716,15,15,15h34.06V420c0,19.299,15.701,35,35,35h49.516   c19.299,0,35-15.701,35-35v-41.811h174.848V420c0,19.299,15.701,35,35,35h49.517c19.299,0,35-15.701,35-35v-41.811H497   c8.284,0,15-6.716,15-15V244.665C512,219.852,491.813,199.665,467,199.665z M150.584,87h210.832l54.846,112.665H95.738L150.584,87   z M138.576,420c0,2.757-2.243,5-5,5H84.06c-2.757,0-5-2.243-5-5v-41.811h59.516V420z M432.94,420c0,2.757-2.243,5-5,5h-49.517   c-2.757,0-5-2.243-5-5v-41.811h59.517V420z M482,348.189c-13.915,0-441.91,0-452,0V244.665c0-8.271,6.729-15,15-15h26.752   c16.395,0,381.632,0,395.248,0c8.271,0,15,6.729,15,15V348.189z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M320.03,273.927H191.97c-8.284,0-15,6.716-15,15s6.716,15,15,15h128.06c8.284,0,15-6.716,15-15   S328.314,273.927,320.03,273.927z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.472,259.939H80.164c-8.432,0-15.201,6.953-14.996,15.366c0.578,23.668,19.897,42.609,43.649,42.609   c23.731,0,43.072-18.918,43.65-42.609C152.674,266.876,145.887,259.939,137.472,259.939z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M431.836,259.939h-57.308c-8.431,0-15.201,6.952-14.995,15.365c0.575,23.623,19.85,42.61,43.648,42.61   c23.774,0,43.072-18.96,43.649-42.609C447.037,266.878,440.254,259.939,431.836,259.939z"
  }))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "nav_cepik",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 22,
    height: 16,
    rx: 3,
    fill: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 9,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71913 12.2861C4.70297 12.7666 4 13.8011 4 14.9997V15.9997C4 16.552 4.44772 16.9997 5 16.9997H11C11.5523 16.9997 12 16.552 12 15.9997V14.9997C12 13.8011 11.297 12.7666 10.2809 12.2861C9.63389 12.736 8.84774 12.9997 8 12.9997C7.15226 12.9997 6.36611 12.736 5.71913 12.2861Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10H19",
    fill: "none",
    strokeWidth: 1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14H19",
    fill: "none",
    strokeWidth: 1,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    id: "nav_clients",
    xmlns: "http://www.w3.org/2000/svg"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M425.629,305.585c-0.208-0.07-0.418-0.135-0.63-0.195l-56.049-15.982l-39.785-37.952v-10.202    c19.039-19.017,31.034-45.285,31.034-74.256v-62C360.2,47.258,313.436,0,255.4,0c-57.897,0-104.999,47.103-104.999,104.999v62    c0,28.971,11.995,55.239,31.034,74.256v10.202l-39.531,37.899l-54.997,16.062c-0.181,0.053-0.36,0.109-0.538,0.168    c-24.143,8.047-38.275,33.594-32.331,58.293l26.518,135.989c1.396,7.162,7.674,12.132,14.706,12.132    c0.417,0,0.837-0.025,1.258-0.061c0.379,0.03,0.757,0.059,1.143,0.059h317.62c7.12,0,13.26-5.006,14.693-11.98l27.964-136.058    C463.937,339.235,449.8,313.642,425.629,305.585z M340.968,304.104l-42.899,64.35l-23.386-23.386l42.432-63.948L340.968,304.104z     M255.399,30c24.494,0,46.28,11.805,59.976,30.021c-14.071,18.679-36.314,29.979-59.976,29.979h-73.491    C188.878,55.808,219.18,30,255.399,30z M180.2,166.999v-47h75.2c27.739,0,54.083-11.091,73.482-30.047    c0.994,4.863,1.518,9.895,1.518,15.047v62c0,41.355-33.645,75-75,75C214.044,241.999,180.2,208.354,180.2,166.999z     M193.685,281.12l42.433,63.948l-23.386,23.386l-42.899-64.35L193.685,281.12z M240.4,481.997H107.636    c-0.112-0.572-24.248-124.413-24.392-124.978c-2.409-9.637,3.023-19.645,12.383-22.896l48.684-14.218l53.609,80.414    c5.24,7.863,16.387,8.988,23.087,2.286l19.394-19.394V481.997z M219.422,265.647c11.228,4.108,23.346,6.351,35.978,6.351    c12.632,0,24.75-2.243,35.978-6.351l-35.978,54.221L219.422,265.647z M428.612,357.637l-25.559,124.36H270.199v-98.786    l19.594,19.394c6.693,6.696,17.842,5.583,23.087-2.286l53.611-80.417l49.92,14.235    C424.607,337.004,431.147,345.425,428.612,357.637z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M375.399,421.998h-30c-8.284,0-15,6.716-15,15s6.716,15,15,15h30c8.284,0,15-6.716,15-15S383.684,421.998,375.399,421.998    z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    id: "nav_home",
    xmlns: "http://www.w3.org/2000/svg"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M511.864,221.487c-0.921-11.988-6.455-22.896-15.581-30.716l-44.286-37.96V44.944c0-8.284-6.716-14.999-14.999-14.999    h-59.998c-8.284,0-14.799,6.716-14.799,14.999v30.728l-75.911-64.695c-16.97-14.539-41.603-14.537-58.519-0.043L15.728,190.769    c-18.753,16.068-21.186,44.423-4.866,63.473c12.439,14.465,32.364,19.077,49.35,13.107v229.584    c0,8.284,6.516,14.999,14.799,14.999h361.986c8.284,0,14.999-6.716,14.999-14.999V267.352c17.534,6.2,37.039,1.004,49.167-13.13    C508.983,245.094,512.784,233.468,511.864,221.487z M391.999,59.943h30.199v67.154l-30.199-25.713V59.943z M317.202,481.934    H195.007V361.738h122.195V481.934z M422.198,481.934h-75.197V346.939c0-8.284-6.716-14.999-14.999-14.999H180.007    c-8.284,0-14.799,6.716-14.799,14.999v134.995H90.011V245.775l166.943-141.613l165.245,141.473V481.934z M478.389,234.694    c-5.318,6.198-14.772,7.107-21.158,1.631L266.765,73.061c-5.595-4.797-13.845-4.817-19.464-0.05    C243.242,76.453,55.58,235.643,54.786,236.317c-6.282,5.375-15.782,4.642-21.161-1.615c-5.385-6.285-4.657-15.774,1.569-21.11    L247.238,33.756c5.66-4.848,13.874-4.849,19.53-0.002l209.994,179.795C483.04,218.929,483.767,228.419,478.389,234.694z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M302.002,179.938h-91.996c-8.284,0-14.799,6.716-14.799,14.999v89.996c0,8.284,6.516,14.999,14.799,14.999h91.996    c8.284,0,14.999-6.716,14.999-14.999v-89.996C317.002,186.653,310.286,179.938,302.002,179.938z M287.203,269.935h-62.198v-59.998    h62.198V269.935z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 271.999,
    cy: 406.934,
    r: 14.999
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    id: "nav_quote",
    xmlns: "http://www.w3.org/2000/svg"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M498.791,161.127c-17.545-17.546-46.094-17.545-63.645,0.004c-5.398,5.403-39.863,39.896-45.128,45.166V87.426    c0-12.02-4.681-23.32-13.181-31.819L334.412,13.18C325.913,4.68,314.612,0,302.592,0H45.018c-24.813,0-45,20.187-45,45v422    c0,24.813,20.187,45,45,45h300c24.813,0,45-20.187,45-45V333.631L498.79,224.767C516.377,207.181,516.381,178.715,498.791,161.127    z M300.019,30c2.834,0,8.295-0.491,13.18,4.393l42.426,42.427c4.76,4.761,4.394,9.978,4.394,13.18h-60V30z M360.018,467    c0,8.271-6.728,15-15,15h-300c-8.271,0-15-6.729-15-15V45c0-8.271,6.729-15,15-15h225v75c0,8.284,6.716,15,15,15h75v116.323    c0,0-44.254,44.292-44.256,44.293l-21.203,21.204c-1.646,1.646-2.888,3.654-3.624,5.863l-21.214,63.64    c-1.797,5.39-0.394,11.333,3.624,15.35c4.023,4.023,9.968,5.419,15.35,3.624l63.64-21.213c2.209-0.736,4.217-1.977,5.863-3.624    l1.82-1.82V467z M326.378,312.427l21.213,21.213l-8.103,8.103l-31.819,10.606l10.606-31.82L326.378,312.427z M368.8,312.422    l-21.213-21.213c11.296-11.305,61.465-61.517,72.105-72.166l21.213,21.213L368.8,312.422z M477.573,203.558l-15.463,15.476    l-21.213-21.213l15.468-15.481c5.852-5.849,15.366-5.848,21.214,0C483.426,188.19,483.457,197.673,477.573,203.558z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M285.018,150h-210c-8.284,0-15,6.716-15,15s6.716,15,15,15h210c8.284,0,15-6.716,15-15S293.302,150,285.018,150z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M225.018,210h-150c-8.284,0-15,6.716-15,15s6.716,15,15,15h150c8.284,0,15-6.716,15-15S233.302,210,225.018,210z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M225.018,270h-150c-8.284,0-15,6.716-15,15s6.716,15,15,15h150c8.284,0,15-6.716,15-15S233.302,270,225.018,270z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M225.018,330h-150c-8.284,0-15,6.716-15,15s6.716,15,15,15h150c8.284,0,15-6.716,15-15S233.302,330,225.018,330z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M285.018,422h-90c-8.284,0-15,6.716-15,15s6.716,15,15,15h90c8.284,0,15-6.716,15-15S293.302,422,285.018,422z"
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "notification",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3C8.68629 3 6 5.68629 6 9C6 13 6 15 4 17H20C18 15 18 13 18 9C18 5.68629 15.3137 3 12 3Z",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.5C13.3807 21.5 14.5 20.3807 14.5 19H9.5C9.5 20.3807 10.6193 21.5 12 21.5Z",
    stroke: "none"
  }))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "notification_error",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "#E23009",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15L15 9",
    stroke: "#E23009",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "notification_success",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "#00AF87",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13L11 16L16 8.5",
    stroke: "#00AF87",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "pending",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    fill: "white",
    stroke: "#FF832B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 12.4999V4.99993C11.4999 4.99993 10.8999 4.79993 12.4999 3.99993C14.4999 2.99993 18.9999 6.49993 19.9999 10.9999C20.7999 14.5999 18.6665 17.1666 17.4999 17.9999L11.9999 12.4999Z",
    fill: "#FF832B",
    stroke: "none"
  }))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "phone",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1762 17.4894L18.5805 18.2926L19.1762 17.4894ZM17.483 16.2335L18.0787 15.4303L17.483 16.2335ZM13.7862 17.1526L13.2655 18.0063C13.6047 18.2132 14.0342 18.1997 14.3597 17.9717L13.7862 17.1526ZM8.05039 8.96107L7.47681 8.14192C7.15133 8.36983 6.99165 8.76881 7.07004 9.15835L8.05039 8.96107ZM10.1784 5.80154L11.1369 5.51644L11.1369 5.51644L10.1784 5.80154ZM9.57737 3.78086L8.61887 4.06596L8.61887 4.06596L9.57737 3.78086ZM7.72322 15.294C6.07318 12.9375 5.21569 10.4158 5.12118 8.276C5.02606 6.12212 5.69616 4.50565 6.90237 3.66105L5.75521 2.02275C3.79459 3.39559 3.01005 5.80375 3.12313 8.36424C3.23684 10.9388 4.2504 13.8212 6.08492 16.4412L7.72322 15.294ZM18.3739 20.0441C17.1677 20.8887 15.4195 20.9655 13.4281 20.1395C11.4496 19.3188 9.37326 17.6505 7.72322 15.294L6.08492 16.4412C7.91943 19.0611 10.2814 20.9994 12.6618 21.9868C15.0292 22.9688 17.5604 23.0552 19.521 21.6824L18.3739 20.0441ZM19.521 21.6824L19.7055 21.5533L18.5583 19.915L18.3739 20.0441L19.521 21.6824ZM19.7055 21.5533C21.3828 20.3788 21.4166 17.9061 19.772 16.6863L18.5805 18.2926C19.1287 18.6992 19.1174 19.5235 18.5583 19.915L19.7055 21.5533ZM19.772 16.6863L18.0787 15.4303L16.8872 17.0367L18.5805 18.2926L19.772 16.6863ZM18.0787 15.4303C17.0416 14.6611 15.6285 14.6418 14.5708 15.3824L15.7179 17.0207C16.0705 16.7738 16.5415 16.7803 16.8872 17.0367L18.0787 15.4303ZM14.5708 15.3824L13.2126 16.3334L14.3597 17.9717L15.7179 17.0207L14.5708 15.3824ZM9.36152 14.1469C10.544 15.8357 11.9372 17.1963 13.2655 18.0063L14.3068 16.2988C13.2672 15.6648 12.0642 14.5199 10.9998 12.9997L9.36152 14.1469ZM7.07004 9.15835C7.37695 10.6835 8.17902 12.4581 9.36152 14.1469L10.9998 12.9997C9.93542 11.4796 9.27095 9.95753 9.03074 8.7638L7.07004 9.15835ZM8.835 7.1909L7.47681 8.14192L8.62396 9.78022L9.98216 8.82921L8.835 7.1909ZM9.21992 6.08665C9.34264 6.49921 9.18759 6.94402 8.835 7.1909L9.98216 8.82921C11.0399 8.08855 11.5051 6.75414 11.1369 5.51644L9.21992 6.08665ZM8.61887 4.06596L9.21992 6.08665L11.1369 5.51644L10.5359 3.49575L8.61887 4.06596ZM7.0868 3.53191C7.64592 3.14041 8.42427 3.41173 8.61887 4.06596L10.5359 3.49575C9.95207 1.53306 7.617 0.71911 5.93965 1.89361L7.0868 3.53191ZM6.90237 3.66105L7.0868 3.53191L5.93965 1.89361L5.75521 2.02275L6.90237 3.66105Z",
    stroke: "none"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "pin",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4H12H16V6L15 7V10L16.8284 11.8284C17.5786 12.5786 18 13.596 18 14.6569V17H6V14.6569C6 13.596 6.42143 12.5786 7.17157 11.8284L9 10V7L8 6V4Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16H13V21L12 23L11 21V16Z",
    fill: "black",
    fillOpacity: 0.2
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "pin_filled",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4H12H16V6L15 7V10L16.8284 11.8284C17.5786 12.5786 18 13.596 18 14.6569V17H6V14.6569C6 13.596 6.42143 12.5786 7.17157 11.8284L9 10V7L8 6V4Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16H13V21L12 23L11 21V16Z",
    fill: "black"
  }))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "placeholder",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 4,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16L16 8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "plus",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12H19",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19L12 5",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    fill: "none",
    id: "policy",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 10C8 8.89547 8.8916 7.99316 9.99435 7.92985C13.4766 7.72991 20.6165 6.96056 24 4C27.3835 6.96056 34.5234 7.72991 38.0057 7.92985C39.1084 7.99316 40 8.89547 40 10V26.2406C40 31.0676 37.5133 35.5542 33.42 38.1125L25.06 43.3375C24.4115 43.7428 23.5885 43.7428 22.94 43.3375L14.58 38.1125C10.4867 35.5542 8 31.0676 8 26.2405V10Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 24L22 30L30 18",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "profile_card",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 22,
    height: 16,
    rx: 3,
    fill: "none",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 9,
    r: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71913 12.2861C4.70297 12.7666 4 13.8011 4 14.9997V15.9997C4 16.552 4.44772 16.9997 5 16.9997H11C11.5523 16.9997 12 16.552 12 15.9997V14.9997C12 13.8011 11.297 12.7666 10.2809 12.2861C9.63389 12.736 8.84774 12.9997 8 12.9997C7.15226 12.9997 6.36611 12.736 5.71913 12.2861Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10H19",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14H19",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "question",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10C13 10.3689 12.8008 10.6924 12.4993 10.8668C11.1984 11.6193 11 12.815 11 13.5V14H13V13.5C13 13.3333 13.023 13.1696 13.0876 13.025C13.1453 12.8961 13.2531 12.7413 13.5007 12.598C14.3948 12.0808 15 11.1117 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10V10.5H11V10ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
    fill: "black"
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "question_white",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10C13 10.3689 12.8008 10.6924 12.4993 10.8668C11.1984 11.6193 11 12.815 11 13.5V14H13V13.5C13 13.3333 13.023 13.1696 13.0876 13.025C13.1453 12.8961 13.2531 12.7413 13.5007 12.598C14.3948 12.0808 15 11.1117 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10V10.5H11V10ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
    fill: "white"
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "quote_check",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 12L11 16L17 7",
    stroke: "white",
    strokeWidth: 2
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "quote_issuing",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1,
    width: 14,
    height: 18,
    rx: 2,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 4H18C19.1046 4 20 4.89543 20 6V20C20 21.1046 19.1046 22 18 22H8C6.89543 22 6 21.1046 6 20V19",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9L13 9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 15L13 15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6L13 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    fill: "none",
    stroke: "none",
    id: "quote_participants",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 25H18C18 24.4477 17.5523 24 17 24V25ZM23 25V24C22.4477 24 22 24.4477 22 25H23ZM16.1818 26H17V24H16.1818V26ZM9 33.1818C9 29.2154 12.2154 26 16.1818 26V24C11.1108 24 7 28.1108 7 33.1818H9ZM9.81818 34C9.36631 34 9 33.6337 9 33.1818H7C7 34.7383 8.26174 36 9.81818 36V34ZM30.1818 34H9.81818V36H30.1818V34ZM31 33.1818C31 33.6337 30.6337 34 30.1818 34V36C31.7383 36 33 34.7383 33 33.1818H31ZM23.8182 26C27.7846 26 31 29.2154 31 33.1818H33C33 28.1108 28.8892 24 23.8182 24V26ZM23 26H23.8182V24H23V26ZM22 25C22 26.1046 21.1046 27 20 27V29C22.2091 29 24 27.2091 24 25H22ZM20 27C18.8954 27 18 26.1046 18 25H16C16 27.2091 17.7909 29 20 29V27Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 12V15.5C27 16.1531 26.5826 16.7087 26 16.9146V18C26 21.866 23.866 24 20 24C16.134 24 14 21.866 14 18V16.9146C13.4174 16.7087 13 16.1531 13 15.5V13",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 11.9999C24 13.9999 18.6544 12.0553 16.917 9.43992C15.8453 10.7688 15.0686 12.7118 13 12.9443C11.5 8.99993 13.0001 4.74783 18 4.99993C22 1.99994 30 6.99994 27 11.9999Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 32.0002L3 32.0002C1.89543 32.0002 1 31.1048 1 30.0002V29.0002C1 27.0285 2.42661 25.39 4.30393 25.0605C4.6575 25.6249 5.28493 26.0002 6 26.0002C6.71507 26.0002 7.3425 25.6249 7.69607 25.0605C8.16371 25.1426 8.60338 25.3059 9 25.5353C9.60725 25.8866 10.1136 26.3929 10.4649 27.0002",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49996 18C9.49996 18.5 9.5 19 9.00005 20C9.00005 21.5 8.00005 23 6.00005 23C4.00005 23 3.00005 21.5 3.00005 20C2.5 19 2.49996 18.5 2.5 18",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 16.8821C8.2858 18.0586 5.49278 17.5382 4.5 15.9998C3.88761 16.7815 3.1821 17.3009 2.00009 17.4377C1.14293 15.1174 2.0001 12.6162 4.85723 12.7645C7.14294 10.9998 11 13.9998 10.0001 16.8821Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 17L30.7708 20.2491C30.9003 21.804 32.2001 23 33.7604 23H34.2396C35.7999 23 37.0997 21.804 37.2292 20.2491L37.5 17",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 17.0002C31.5 17.0002 32.5 16.5001 33 16.0001C35 17.0001 36.5 17.0002 37.5 17.0002C39 13.0001 34.9999 12.0002 33 12.5001C30.4999 12.0001 29.4999 16.0002 30.5 17.0002Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 32H37C38.1046 32 39 31.1046 39 30C39 27.7909 37.2091 26 35 26H33C31.8053 26 30.7329 26.5238 30 27.3542",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    fill: "none",
    id: "quote_policy",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 9.00002C5 6.79089 6.79305 4.98744 8.98842 4.74123C12.4292 4.35536 17.2638 3.3942 20 1C22.7362 3.3942 27.5708 4.35536 31.0116 4.74123C33.207 4.98744 35 6.79089 35 9.00003V21.5074C35 26.1884 32.6606 30.5596 28.7658 33.1561L21.1094 38.2604C20.4376 38.7083 19.5624 38.7083 18.8906 38.2604L11.2342 33.1561C7.33942 30.5596 5 26.1884 5 21.5074V9.00002Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9.5C9 8.94772 9.44487 8.49515 9.99598 8.45916C11.9899 8.32897 16.5744 7.7837 20 5.5C23.4256 7.7837 28.0101 8.32897 30.004 8.45916C30.5551 8.49515 31 8.94772 31 9.5V20.9616C31 24.7225 29.0786 28.2228 25.9056 30.2419L20.5369 33.6584C20.2093 33.8668 19.7907 33.8668 19.4631 33.6584L14.0944 30.2419C10.9214 28.2228 9 24.7225 9 20.9616V9.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 20L19 25L25 15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    fill: "none",
    id: "quote_summary",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 5C7 3.89543 7.89543 3 9 3H31C32.1046 3 33 3.89543 33 5V30.4712C33 31.0215 32.7733 31.5474 32.3732 31.9253L27.5781 36.454C27.2068 36.8047 26.7155 37 26.2048 37H9C7.89543 37 7 36.1046 7 35V5Z",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 37V32C26 30.8954 26.8954 30 28 30H33",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 22H27",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 26H27",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 30H20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12L15 15L19 9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    fill: "none",
    id: "quote_vehicle",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 25.5,
    r: 3.5,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 25L3.27239 24.5681C1.93689 24.2342 1 23.0343 1 21.6577V18.5616C1 17.6438 1.62459 16.8439 2.51493 16.6213L5 16L9.60933 12.1589C10.5079 11.4101 11.6406 11 12.8102 11H20.3333C21.4152 11 22.4679 11.3509 23.3333 12L30 17L36.3313 17.7035C37.8506 17.8723 39 19.1565 39 20.6851V22C39 23.6569 37.6569 25 36 25V25",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 25.5,
    r: 3.5,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 18L10.4721 18C10.1616 18 9.85542 17.9277 9.57771 17.7889L8 17",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 21L21 21",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 25H29",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 14L17 17",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "remove",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 4,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16L16 8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "robot",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 8V4H8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    x: 4,
    y: 8,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 14h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13v2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13v2"
  }))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "role_agent",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 14L6.42174 21.1022C6.20531 22.0761 6.94643 23 7.94414 23V23C8.58184 23 9.1553 22.6118 9.39214 22.0197L11 18",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14L15.5783 21.1022C15.7947 22.0761 15.0536 23 14.0559 23V23C13.4182 23 12.8447 22.6118 12.6079 22.0197L11 18",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8533 7.68297L11.6626 7.92638C11.2222 7.97531 10.7778 7.97531 10.3374 7.92638L8.14672 7.68297C7.09234 7.56582 6.03461 7.87231 5.20621 8.53503L4.11731 9.40615C2.72109 10.5231 2.60574 12.6057 3.87008 13.8701L4.75 14.75C5.44036 15.4404 6.55964 15.4404 7.25 14.75C7.94036 14.0596 7.94036 12.9404 7.25 12.25L6.5 11.5L8 11V14H14V11L15.5 11.5L14.75 12.25C14.0596 12.9404 14.0596 14.0596 14.75 14.75C15.4404 15.4404 16.5596 15.4404 17.25 14.75L18.1299 13.8701C19.3943 12.6057 19.2789 10.5231 17.8827 9.40615L16.7938 8.53503C15.9654 7.87231 14.9077 7.56582 13.8533 7.68297Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 4,
    r: 3,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21H22L18 14",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 14 14",
    fill: "none",
    id: "search",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10L13 13",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "search_input",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7695 17.7695L23 23",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "search_spaced",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 7,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16L20 20",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "send",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.854 2.147-10.94 10.939"
  }))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "settings",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M10.2534 4.47959L9.26701 4.31519V4.31519L10.2534 4.47959ZM13.7466 4.47959L12.7602 4.64399V4.64399L13.7466 4.47959ZM13.8757 5.25414L12.8893 5.41854C12.9532 5.80207 13.2337 6.11378 13.6083 6.21774L13.8757 5.25414ZM15.4432 5.90399L14.9506 6.77425C15.2891 6.96584 15.708 6.9438 16.0245 6.71773L15.4432 5.90399ZM16.0827 5.44724L15.5015 4.6335L16.0827 5.44724ZM18.364 5.63604L19.0711 4.92893V4.92893L18.364 5.63604ZM18.5528 7.9173L17.739 7.33606V7.33606L18.5528 7.9173ZM18.096 8.55676L17.2823 7.97552C17.0562 8.29202 17.0342 8.71089 17.2258 9.04937L18.096 8.55676ZM18.7459 10.1243L17.7823 10.3917C17.8862 10.7663 18.1979 11.0468 18.5815 11.1107L18.7459 10.1243ZM19.5204 10.2534L19.356 11.2398L19.5204 10.2534ZM19.5204 13.7466L19.356 12.7602L19.5204 13.7466ZM18.7459 13.8757L18.5815 12.8893C18.1979 12.9532 17.8862 13.2337 17.7823 13.6083L18.7459 13.8757ZM18.096 15.4433L17.2257 14.9507C17.0341 15.2891 17.0562 15.708 17.2823 16.0245L18.096 15.4433ZM18.5527 16.0827L17.739 16.6639V16.6639L18.5527 16.0827ZM16.0827 18.5528L16.6639 17.739L16.6639 17.739L16.0827 18.5528ZM15.4432 18.096L16.0244 17.2823C15.708 17.0562 15.2891 17.0342 14.9506 17.2258L15.4432 18.096ZM13.8757 18.7459L13.6083 17.7823C13.2337 17.8862 12.9532 18.1979 12.8893 18.5815L13.8757 18.7459ZM13.7466 19.5204L12.7602 19.356L13.7466 19.5204ZM10.2534 19.5204L11.2398 19.356L10.2534 19.5204ZM10.1243 18.7459L11.1107 18.5815C11.0468 18.1979 10.7663 17.8862 10.3917 17.7823L10.1243 18.7459ZM8.55676 18.096L9.04937 17.2258C8.71089 17.0342 8.29202 17.0562 7.97552 17.2823L8.55676 18.096ZM7.9173 18.5528L7.33606 17.739H7.33606L7.9173 18.5528ZM5.63604 18.364L4.92893 19.0711H4.92893L5.63604 18.364ZM5.44724 16.0827L4.6335 15.5015L5.44724 16.0827ZM5.90399 15.4432L6.71773 16.0245C6.9438 15.708 6.96584 15.2891 6.77425 14.9506L5.90399 15.4432ZM5.25414 13.8757L6.21774 13.6083C6.11378 13.2337 5.80207 12.9532 5.41854 12.8893L5.25414 13.8757ZM4.47959 13.7466L4.64399 12.7602H4.64399L4.47959 13.7466ZM4.47959 10.2534L4.31519 9.26701H4.31519L4.47959 10.2534ZM5.25414 10.1243L5.41854 11.1107C5.80207 11.0468 6.11379 10.7663 6.21774 10.3917L5.25414 10.1243ZM5.90398 8.55679L6.77423 9.0494C6.96583 8.71092 6.94378 8.29205 6.71771 7.97555L5.90398 8.55679ZM5.4472 7.91731L4.63347 8.49855H4.63347L5.4472 7.91731ZM5.636 5.63605L6.34311 6.34315H6.34311L5.636 5.63605ZM7.91727 5.44724L8.4985 4.63351V4.63351L7.91727 5.44724ZM8.55674 5.90401L7.9755 6.71774C8.292 6.94381 8.71087 6.96586 9.04935 6.77426L8.55674 5.90401ZM10.1243 5.25414L10.3917 6.21774C10.7663 6.11379 11.0468 5.80207 11.1107 5.41854L10.1243 5.25414ZM12 2C10.6456 2 9.48967 2.9792 9.26701 4.31519L11.2398 4.64399C11.3017 4.27237 11.6233 4 12 4V2ZM14.733 4.31519C14.5103 2.9792 13.3544 2 12 2V4C12.3767 4 12.6983 4.27237 12.7602 4.64399L14.733 4.31519ZM14.8621 5.08974L14.733 4.31519L12.7602 4.64399L12.8893 5.41854L14.8621 5.08974ZM13.6083 6.21774C14.0817 6.34907 14.5317 6.5371 14.9506 6.77425L15.9358 5.03374C15.3769 4.71736 14.7758 4.46611 14.143 4.29054L13.6083 6.21774ZM15.5015 4.6335L14.862 5.09026L16.0245 6.71773L16.6639 6.26097L15.5015 4.6335ZM19.0711 4.92893C18.1133 3.97121 16.6036 3.84626 15.5015 4.6335L16.6639 6.26097C16.9705 6.04199 17.3905 6.07675 17.6569 6.34315L19.0711 4.92893ZM19.3665 8.49854C20.1537 7.3964 20.0288 5.88665 19.0711 4.92893L17.6569 6.34315C17.9233 6.60954 17.958 7.02949 17.739 7.33606L19.3665 8.49854ZM18.9097 9.138L19.3665 8.49854L17.739 7.33606L17.2823 7.97552L18.9097 9.138ZM17.2258 9.04937C17.4629 9.46832 17.6509 9.91831 17.7823 10.3917L19.7095 9.85696C19.5339 9.22417 19.2826 8.62308 18.9663 8.06415L17.2258 9.04937ZM19.6848 9.26701L18.9103 9.13792L18.5815 11.1107L19.356 11.2398L19.6848 9.26701ZM22 12C22 10.6456 21.0208 9.48967 19.6848 9.26701L19.356 11.2398C19.7276 11.3017 20 11.6233 20 12H22ZM19.6848 14.733C21.0208 14.5103 22 13.3544 22 12H20C20 12.3767 19.7276 12.6983 19.356 12.7602L19.6848 14.733ZM18.9103 14.8621L19.6848 14.733L19.356 12.7602L18.5815 12.8893L18.9103 14.8621ZM17.7823 13.6083C17.6509 14.0817 17.4629 14.5317 17.2257 14.9507L18.9662 15.9359C19.2826 15.3769 19.5339 14.7758 19.7095 14.143L17.7823 13.6083ZM19.3665 15.5015L18.9097 14.862L17.2823 16.0245L17.739 16.6639L19.3665 15.5015ZM19.071 19.0711C20.0288 18.1134 20.1537 16.6036 19.3665 15.5015L17.739 16.6639C17.958 16.9705 17.9232 17.3905 17.6568 17.6569L19.071 19.0711ZM15.5014 19.3665C16.6036 20.1537 18.1133 20.0288 19.071 19.0711L17.6568 17.6569C17.3904 17.9233 16.9705 17.958 16.6639 17.739L15.5014 19.3665ZM14.862 18.9098L15.5014 19.3665L16.6639 17.739L16.0244 17.2823L14.862 18.9098ZM14.9506 17.2258C14.5317 17.4629 14.0817 17.6509 13.6083 17.7823L14.143 19.7095C14.7758 19.5339 15.3769 19.2826 15.9358 18.9663L14.9506 17.2258ZM14.733 19.6848L14.8621 18.9103L12.8893 18.5815L12.7602 19.356L14.733 19.6848ZM12 22C13.3544 22 14.5103 21.0208 14.733 19.6848L12.7602 19.356C12.6983 19.7276 12.3767 20 12 20V22ZM9.26701 19.6848C9.48967 21.0208 10.6456 22 12 22V20C11.6233 20 11.3017 19.7276 11.2398 19.356L9.26701 19.6848ZM9.13792 18.9103L9.26701 19.6848L11.2398 19.356L11.1107 18.5815L9.13792 18.9103ZM10.3917 17.7823C9.91831 17.6509 9.46832 17.4629 9.04937 17.2258L8.06415 18.9663C8.62308 19.2826 9.22417 19.5339 9.85696 19.7095L10.3917 17.7823ZM8.49854 19.3665L9.138 18.9097L7.97552 17.2823L7.33606 17.739L8.49854 19.3665ZM4.92893 19.0711C5.88665 20.0288 7.3964 20.1537 8.49854 19.3665L7.33606 17.739C7.02949 17.958 6.60954 17.9233 6.34315 17.6569L4.92893 19.0711ZM4.6335 15.5015C3.84626 16.6036 3.97121 18.1133 4.92893 19.0711L6.34315 17.6569C6.07675 17.3905 6.04199 16.9705 6.26097 16.6639L4.6335 15.5015ZM5.09026 14.862L4.6335 15.5015L6.26097 16.6639L6.71773 16.0245L5.09026 14.862ZM6.77425 14.9506C6.5371 14.5317 6.34907 14.0817 6.21774 13.6083L4.29054 14.143C4.46611 14.7758 4.71736 15.3769 5.03374 15.9358L6.77425 14.9506ZM4.31519 14.733L5.08974 14.8621L5.41854 12.8893L4.64399 12.7602L4.31519 14.733ZM2 12C2 13.3544 2.9792 14.5103 4.31519 14.733L4.64399 12.7602C4.27237 12.6983 4 12.3767 4 12H2ZM4.31519 9.26701C2.9792 9.48967 2 10.6456 2 12H4C4 11.6233 4.27237 11.3017 4.64399 11.2398L4.31519 9.26701ZM5.08974 9.13792L4.31519 9.26701L4.64399 11.2398L5.41854 11.1107L5.08974 9.13792ZM6.21774 10.3917C6.34907 9.91832 6.53709 9.46834 6.77423 9.0494L5.03372 8.06419C4.71735 8.62311 4.4661 9.22418 4.29054 9.85696L6.21774 10.3917ZM4.63347 8.49855L5.09024 9.13803L6.71771 7.97555L6.26094 7.33607L4.63347 8.49855ZM4.9289 4.92894C3.97118 5.88666 3.84623 7.39641 4.63347 8.49855L6.26094 7.33607C6.04196 7.0295 6.07671 6.60955 6.34311 6.34315L4.9289 4.92894ZM8.4985 4.63351C7.39637 3.84627 5.88662 3.97122 4.9289 4.92894L6.34311 6.34315C6.60951 6.07676 7.02946 6.042 7.33603 6.26098L8.4985 4.63351ZM9.13797 5.09028L8.4985 4.63351L7.33603 6.26098L7.9755 6.71774L9.13797 5.09028ZM9.04935 6.77426C9.4683 6.5371 9.9183 6.34907 10.3917 6.21774L9.85696 4.29054C9.22416 4.46611 8.62306 4.71737 8.06413 5.03376L9.04935 6.77426ZM9.26701 4.31519L9.13792 5.08974L11.1107 5.41854L11.2398 4.64399L9.26701 4.31519Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    stroke: "black",
    fill: "none",
    strokeWidth: 2
  }))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "show",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dgclip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7L7 7C5.34315 7 4 8.34315 4 10L4 17C4 18.6569 5.34315 20 7 20L14 20C15.6569 20 17 18.6569 17 17V12",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10L20 4L14 4",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4L12 12",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dgclip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "signout",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7.5L14 7C14 5.34315 12.6569 4 11 4L5 4C3.34315 4 2 5.34315 2 7L2 17C2 18.6569 3.34315 20 5 20L11 20C12.6569 20 14 18.6569 14 17L14 16.5",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 16L23 12L19 8",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 12L14 12",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "sole_trader",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 20,
    height: 14,
    rx: 2,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8L5.5 14H9M20.5 8L18.5 14H15",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12,
    width: 4,
    height: 4,
    rx: 1,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7V5C8 3.89543 8.89543 3 10 3H14C15.1046 3 16 3.89543 16 5V7",
    stroke: "black",
    strokeWidth: 2
  }))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sort",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16L12 20L16 16",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8L12 4L16 8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "thumbs-down",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 14V2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z"
  }))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "thumbs-up",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 10v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"
  }))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 14 14",
    id: "tires",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 7,
    rx: 4,
    ry: 6,
    fill: "none",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 7,
    rx: 1,
    ry: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 1H5C2.79086 1 1 3.68629 1 7C1 10.3137 2.79086 13 5 13H9",
    fill: "none",
    strokeWidth: 2
  }))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "trash",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 7H18V19C18 20.1046 17.1046 21 16 21H8C6.89543 21 6 20.1046 6 19V7Z",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7H20",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5C8 3.89543 8.89543 3 10 3H14C15.1046 3 16 3.89543 16 5V7H8V5Z",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11V17",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11V17",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "travel",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 7V2H10.6459C11.4637 2 12.1992 2.4979 12.5029 3.25722L14 7",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10V11",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10V11",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10V11",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10V11",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0458 15H15L12.5195 20.7878C12.2043 21.5232 11.4813 22 10.6812 22H9V15H4C2.34315 15 1 13.6569 1 12V8H2.17157C2.70201 8 3.21071 8.21071 3.58579 8.58579L5 10H18.4861C19.4732 10 20.4383 10.2922 21.2596 10.8397L22.1298 11.4199C22.6735 11.7823 23 12.3925 23 13.0458C23 14.1251 22.1251 15 21.0458 15Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "unavailable",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16L16 8",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16L8 8",
    stroke: "white",
    strokeWidth: 2
  }))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 248 247",
    fill: "none",
    id: "undefined",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.3841 18.8185C103.577 -6.27286 144.423 -6.27283 169.616 18.8186L229.105 78.0681C254.298 103.159 254.298 143.841 229.105 168.932L169.616 228.181C144.423 253.273 103.577 253.273 78.3841 228.181L18.8947 168.932C-6.29826 143.841 -6.29823 103.159 18.8947 78.068L78.3841 18.8185Z",
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.369 148.994V141.284C108.369 120.467 132.677 116.766 132.677 103.813C132.677 98.5706 127.567 94.7156 121.684 94.7156C114.252 94.7156 106.976 101.346 106.976 101.346L92.1124 83.3047C92.1124 83.3047 103.724 70.506 124.471 70.506C141.811 70.506 160.545 80.8375 160.545 100.729C160.545 126.018 134.07 129.719 134.07 143.443V148.994H108.369ZM108.988 183.073V159.943H133.451V183.073H108.988Z",
    fill: "white"
  }))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 40 40",
    fill: "none",
    id: "under_construction",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11,
    width: 34,
    height: 5,
    rx: 2,
    stroke: "#FF7D00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 25H34C35.1046 25 36 24.1046 36 23V22C36 20.8954 35.1046 20 34 20H4C2.89543 20 2 20.8954 2 22V23C2 24.1046 2.89543 25 4 25H25",
    stroke: "#FF7D00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 28H30",
    stroke: "#FF7D00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 23L23.2043 34.1828C23.0842 34.6631 22.6527 35 22.1577 35H21.5C20.6716 35 20 35.6716 20 36.5C20 37.3284 20.6716 38 21.5 38H33.5C34.3284 38 35 37.3284 35 36.5C35 35.6716 34.3284 35 33.5 35H32.8423C32.3473 35 31.9158 34.6631 31.7957 34.1828L29 23H26Z",
    stroke: "#FF7D00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 31H31",
    stroke: "#FF7D00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 35H33",
    stroke: "#FF7D00",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20V16",
    stroke: "#FF7D00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11V8H8V11",
    stroke: "#FF7D00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16V20",
    stroke: "#FF7D00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 25V31H8V25",
    stroke: "#FF7D00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 20V16",
    stroke: "#FF7D00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 11V8H34V11",
    stroke: "#FF7D00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 16V20",
    stroke: "#FF7D00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 5,
    r: 3,
    stroke: "#FF7D00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 5,
    r: 3,
    stroke: "#FF7D00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 25V31H31",
    stroke: "#FF7D00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    fill: "none",
    id: "unknown",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.54395,
    width: 13.4973,
    height: 13.4973,
    rx: 2,
    transform: "rotate(45 9.54395 0)",
    fill: "#24A148",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12L12 7",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "upload",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 16V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V16",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7L12 2L17 7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16V2",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol92 || (_symbol92 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "user",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.43826 13.5728L8.00915 12.7518L7.53399 12.4214L7.01079 12.6688L7.43826 13.5728ZM16.5617 13.5728L16.9892 12.6688L16.466 12.4214L15.9909 12.7518L16.5617 13.5728ZM5 19C5 17.0038 6.16982 15.2788 7.86573 14.4768L7.01079 12.6688C4.64206 13.7888 3 16.2017 3 19H5ZM6 20C5.44772 20 5 19.5523 5 19H3C3 20.6569 4.34315 22 6 22V20ZM12 20H6V22H12V20ZM18 20H12V22H18V20ZM19 19C19 19.5523 18.5523 20 18 20V22C19.6569 22 21 20.6569 21 19H19ZM16.1343 14.4768C17.8302 15.2788 19 17.0038 19 19H21C21 16.2017 19.3579 13.7888 16.9892 12.6688L16.1343 14.4768ZM15.9909 12.7518C14.859 13.5388 13.4849 14 12 14V16C13.9061 16 15.6765 15.4063 17.1326 14.3938L15.9909 12.7518ZM12 14C10.5151 14 9.14096 13.5388 8.00915 12.7518L6.86737 14.3938C8.3235 15.4063 10.0939 16 12 16V14Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 4,
    fill: "none",
    strokeWidth: 2
  }))), _symbol93 || (_symbol93 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "user_white",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.43826 13.5728L8.00915 12.7517L7.53399 12.4213L7.01079 12.6687L7.43826 13.5728ZM16.5617 13.5728L16.9892 12.6687L16.466 12.4213L15.9909 12.7517L16.5617 13.5728ZM5 18.9999C5 17.0037 6.16982 15.2787 7.86573 14.4768L7.01079 12.6687C4.64206 13.7888 3 16.2016 3 18.9999H5ZM6 19.9999C5.44772 19.9999 5 19.5522 5 18.9999H3C3 20.6568 4.34315 21.9999 6 21.9999V19.9999ZM12 19.9999H6V21.9999H12V19.9999ZM18 19.9999H12V21.9999H18V19.9999ZM19 18.9999C19 19.5522 18.5523 19.9999 18 19.9999V21.9999C19.6569 21.9999 21 20.6568 21 18.9999H19ZM16.1343 14.4768C17.8302 15.2787 19 17.0037 19 18.9999H21C21 16.2016 19.3579 13.7888 16.9892 12.6687L16.1343 14.4768ZM15.9909 12.7517C14.859 13.5387 13.4849 13.9999 12 13.9999V15.9999C13.9061 15.9999 15.6765 15.4063 17.1326 14.3938L15.9909 12.7517ZM12 13.9999C10.5151 13.9999 9.14096 13.5387 8.00915 12.7517L6.86737 14.3938C8.3235 15.4063 10.0939 15.9999 12 15.9999V13.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 4,
    stroke: "white",
    strokeWidth: 2
  }))), _symbol94 || (_symbol94 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "vehicle",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4142 7.58579C10.7893 7.21071 11.298 7 11.8284 7H16C16.6295 7 17.2223 7.29639 17.6 7.8L20 11H7L10.4142 7.58579Z",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16V17C5.55228 17 6 16.5523 6 16H5ZM9 16H8C8 16.5523 8.44772 17 9 17V16ZM16 16V17C16.5523 17 17 16.5523 17 16H16ZM20 16H19C19 16.5523 19.4477 17 20 17V16ZM3 13C3 12.4477 3.44772 12 4 12V10C2.34315 10 1 11.3431 1 13H3ZM3 14V13H1V14H3ZM4 15C3.44772 15 3 14.5523 3 14H1C1 15.6569 2.34315 17 4 17V15ZM5 15H4V17H5V15ZM7 13C5.34315 13 4 14.3431 4 16H6C6 15.4477 6.44772 15 7 15V13ZM10 16C10 14.3431 8.65685 13 7 13V15C7.55228 15 8 15.4477 8 16H10ZM16 15H9V17H16V15ZM18 13C16.3431 13 15 14.3431 15 16H17C17 15.4477 17.4477 15 18 15V13ZM21 16C21 14.3431 19.6569 13 18 13V15C18.5523 15 19 15.4477 19 16H21ZM21 14C21 14.5523 20.5523 15 20 15V17C21.6569 17 23 15.6569 23 14H21ZM21 13V14H23V13H21ZM20 12C20.5523 12 21 12.4477 21 13H23C23 11.3431 21.6569 10 20 10V12ZM4 12H20V10H4V12Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 16,
    r: 2,
    fill: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 16,
    r: 2,
    fill: "white",
    strokeWidth: 2
  }))), _symbol95 || (_symbol95 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "vehicle_orange",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4142 7.58579C10.7893 7.21071 11.298 7 11.8284 7H16C16.6295 7 17.2223 7.29639 17.6 7.8L20 11H7L10.4142 7.58579Z",
    stroke: "#FF7D00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16V17C5.55228 17 6 16.5523 6 16H5ZM9 16H8C8 16.5523 8.44772 17 9 17V16ZM16 16V17C16.5523 17 17 16.5523 17 16H16ZM20 16H19C19 16.5523 19.4477 17 20 17V16ZM3 13C3 12.4477 3.44772 12 4 12V10C2.34315 10 1 11.3431 1 13H3ZM3 14V13H1V14H3ZM4 15C3.44772 15 3 14.5523 3 14H1C1 15.6569 2.34315 17 4 17V15ZM5 15H4V17H5V15ZM7 13C5.34315 13 4 14.3431 4 16H6C6 15.4477 6.44772 15 7 15V13ZM10 16C10 14.3431 8.65685 13 7 13V15C7.55228 15 8 15.4477 8 16H10ZM16 15H9V17H16V15ZM18 13C16.3431 13 15 14.3431 15 16H17C17 15.4477 17.4477 15 18 15V13ZM21 16C21 14.3431 19.6569 13 18 13V15C18.5523 15 19 15.4477 19 16H21ZM21 14C21 14.5523 20.5523 15 20 15V17C21.6569 17 23 15.6569 23 14H21ZM21 13V14H23V13H21ZM20 12C20.5523 12 21 12.4477 21 13H23C23 11.3431 21.6569 10 20 10V12ZM4 12H20V10H4V12Z",
    fill: "#FF7D00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 16,
    r: 2,
    stroke: "#FF7D00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 16,
    r: 2,
    stroke: "#FF7D00",
    strokeWidth: 2
  }))), _symbol96 || (_symbol96 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "wheel_orange",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.7053 17.5281L7.09125 18.3174L7.7053 17.5281ZM16.2947 17.5281L15.6806 16.7389L16.2947 17.5281ZM18 12C18 13.9258 17.0939 15.6394 15.6806 16.7389L16.9088 18.3174C18.788 16.8553 20 14.5689 20 12H18ZM12 6C15.3137 6 18 8.68629 18 12H20C20 7.58172 16.4183 4 12 4V6ZM6 12C6 8.68629 8.68629 6 12 6V4C7.58172 4 4 7.58172 4 12H6ZM8.31935 16.7389C6.90613 15.6394 6 13.9258 6 12H4C4 14.5689 5.21196 16.8553 7.09125 18.3174L8.31935 16.7389ZM9.2264 19H14.7736V17H9.2264V19ZM7.09125 18.3174C7.74331 18.8247 8.52439 19 9.2264 19V17C8.83712 17 8.52861 16.9017 8.31935 16.7389L7.09125 18.3174ZM15.6806 16.7389C15.4714 16.9017 15.1629 17 14.7736 17V19C15.4756 19 16.2567 18.8247 16.9088 18.3174L15.6806 16.7389Z",
    fill: "#FF7D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12L5 12",
    stroke: "#FF7D00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 12L14 12",
    stroke: "#FF7D00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14V19",
    stroke: "#FF7D00",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15C13.6569 15 15.5 13.5 15.5 12C15.5 10.5 14 10 12 10C10 10 8.5 10.5 8.5 12C8.5 13.5 10.3431 15 12 15ZM12 13C12.5523 13 13 12.7761 13 12.5C13 12.2239 12.5523 12 12 12C11.4477 12 11 12.2239 11 12.5C11 12.7761 11.4477 13 12 13Z",
    fill: "#FF7D00"
  }))), _symbol97 || (_symbol97 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "world",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM4 12C4 11.101 4.156 10.238 4.431 9.431L6 11L8 13V15L10 17L11 18V19.931C7.061 19.436 4 16.072 4 12ZM18.33 16.873C17.677 16.347 16.687 16 16 16V15C16 14.4696 15.7893 13.9609 15.4142 13.5858C15.0391 13.2107 14.5304 13 14 13H10V10C10.5304 10 11.0391 9.78929 11.4142 9.41421C11.7893 9.03914 12 8.53043 12 8V7H13C13.5304 7 14.0391 6.78929 14.4142 6.41421C14.7893 6.03914 15 5.53043 15 5V4.589C17.928 5.778 20 8.65 20 12C19.9998 13.7647 19.4123 15.4791 18.33 16.873Z",
    fill: "black"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.021041826f633c7a76ec63a8f67ea73c.svg";
export { ForwardRef as ReactComponent };